import { ORDER, ORDER_POSITION } from '@hive/status'

export const ORDER_STATUS = {
  [ORDER.NOT_CONFIRMED]: {
    // Ожидает подтверждения
    title: 'not_confirmed',
    color: 'danger',
  },
  [ORDER.CONFIRMED]: {
    //Заказ размещен
    title: 'confirmed',
    color: 'light',
  },
  [ORDER.ASSEMBLY_IN_PROGRESS]: {
    title: 'assembly_in_progress', // Собирается
    color: 'primary',
  },
  [ORDER.ASSEMBLY_COMPLETE]: {
    title: 'assembly_complete', //Сборка завершена
    color: 'success',
  },
  [ORDER.WAITING_FOR_PAYMENT]: {
    title: 'waiting_for_payment', //Ожидает оплаты
    color: 'warning',
  },
  [ORDER.PACKING]: {
    title: 'packing', //Упаковывается
    color: 'primary',
  },
  [ORDER.WAITING_FOR_COURIER]: {
    title: 'waiting_for_courier', //Ожидает курьера
    color: 'primary',
  },
  [ORDER.WAITING_FOR_PICKUP]: {
    //Ожидает самовывоза
    title: 'waiting_for_pickup',
    color: 'primary',
  },
  [ORDER.REFUNDED]: {
    //Возвращен
    title: 'refunded',
    color: 'danger',
  },
  [ORDER.ACCEPTED_BY_COURIER]: {
    title: 'accepted_by_courier', // Курьер забрал заказ
    color: 'primary',
  },
  [ORDER.DELIVERY_IN_PROGRESS]: {
    title: 'delivery_in_progress', // Доставляется
    color: 'primary',
  },
  [ORDER.CANCELED]: {
    // Отменен
    title: 'canceled',
    color: 'danger',
  },
  [ORDER.WAITING_FOR_POST_PAYMENT]: {
    //Ожидает оплаты при получении
    title: 'waiting_for_post_payment',
    color: 'warning',
  },
  [ORDER.DELIVERED]: {
    //Доставлен
    title: 'delivered',
    color: 'success',
  },
}

export const ORDER_POSITION_STATUS: Record<number, { title: string; color: string }> = {
  [ORDER_POSITION.NEED_CONTACT]: {
    title: 'need_contact', // Требует контакта - будет заменен/удален/изменение
    color: 'warning',
  },
  [ORDER_POSITION.REPLACED]: {
    title: 'replaced', // Заменен, в пропсах есть id на какой товар заменен
    color: 'primary',
  },
  [ORDER_POSITION.REMOVED]: {
    title: 'removed', // Удален
    color: 'danger',
  },
  [ORDER_POSITION.ASSEMBLED]: {
    title: 'assembled', // Собран
    color: 'success',
  },
  [ORDER_POSITION.REFUNDED]: {
    title: 'refunded', // Возвращен
    color: 'danger',
  },
  [ORDER_POSITION.REFUNDED_BEFORE_COMPLETE]: {
    title: 'refunded', // Возвращен до завершения сборки - для клиента объединяем с REFUNDED
    color: 'danger',
  },
}
